import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {
    Breadcrumb,
    Grid, Table, Checkbox
} from 'semantic-ui-react';
import CustomDivider from '../../components/extras/CustomDivider';
import connect from "react-redux/es/connect/connect";
import {showToast} from "../../actions/ToastAction";
import Loading from "../../components/extras/Loading";
import CheckPermission from "../../components/extras/CheckPermission";
import SecurityStoreData from "../../data/SecurityStoreData";


class OtherSecurities extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:{
                only_admins_can_close_box: false,
                sellers_can_view_box: true,
                sellers_can_cancel_sale: true,
                sellers_can_view_home: true,
                sellers_can_view_customer_details: false,
                lock_sale_items: false
            }
        }
    }

    componentDidMount() {
        this.initialFetch();
    }

    async initialFetch() {
        await SecurityStoreData.get(res => {
            if(!res.hasOwnProperty('detail')){
                this.setState({
                    data: res
                });
            }
        });
    };

    handleToggleChange = (e, { name, value }) => {
        let data = this.state.data;
        data[name] = !value;
        this.setState({data});
        SecurityStoreData.update(data, res =>{
            if(res && res.update){
                this.setState({data:res.data});
                this.props.showToast({message:'Configuración actualizada!', type:'success'});
            }else{
                this.props.showToast({message:'Tenemos un problema!', type:'error'});
            }
        }).catch(()=>{
            this.props.showToast({message:'Tenemos un problema!', type:'error'});
        });
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Mi Sitio Web | Seguridad - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/security'>Seguridad</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Otras Configuraciones</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Grid>
                    {!this.state.loading ?<Grid.Row>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Table celled>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={3} textAlign='center'>Otras Configuraciones de Seguridad</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell><strong>Sólo los propietarios y administradores pueden cerrar la caja</strong></Table.Cell>
                                        <Table.Cell>
                                            <Table.Cell colSpan={2}>
                                                <Checkbox toggle checked={this.state.data.only_admins_can_close_box} value={this.state.data.only_admins_can_close_box} name='only_admins_can_close_box' label={`${this.state.data.only_admins_can_close_box ? 'Si' : 'No'}`} onChange={this.handleToggleChange}/>
                                            </Table.Cell>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Los vendedores pueden ver lo que hay en caja</strong></Table.Cell>
                                        <Table.Cell>
                                            <Table.Cell colSpan={2}>
                                                <Checkbox toggle checked={this.state.data.sellers_can_view_box} value={this.state.data.sellers_can_view_box} name='sellers_can_view_box' label={`${this.state.data.sellers_can_view_box ? 'Si' : 'No'}`} onChange={this.handleToggleChange}/>
                                            </Table.Cell>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Los vendedores pueden anular ventas</strong></Table.Cell>
                                        <Table.Cell>
                                            <Table.Cell colSpan={2}>
                                                <Checkbox toggle checked={this.state.data.sellers_can_cancel_sale} value={this.state.data.sellers_can_cancel_sale} name='sellers_can_cancel_sale' label={`${this.state.data.sellers_can_cancel_sale ? 'Si' : 'No'}`} onChange={this.handleToggleChange}/>
                                            </Table.Cell>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Los vendedores pueden ver el menu de inicio</strong></Table.Cell>
                                        <Table.Cell>
                                            <Table.Cell colSpan={2}>
                                                <Checkbox toggle checked={this.state.data.sellers_can_view_home} value={this.state.data.sellers_can_view_home} name='sellers_can_view_home' label={`${this.state.data.sellers_can_view_home ? 'Si' : 'No'}`} onChange={this.handleToggleChange}/>
                                            </Table.Cell>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Los vendedores pueden ver inforación de consumo de los clientes</strong></Table.Cell>
                                        <Table.Cell>
                                            <Table.Cell colSpan={2}>
                                                <Checkbox toggle checked={this.state.data.sellers_can_view_customer_details} value={this.state.data.sellers_can_view_customer_details} name='sellers_can_view_customer_details' label={`${this.state.data.sellers_can_view_customer_details ? 'Si' : 'No'}`} onChange={this.handleToggleChange}/>
                                            </Table.Cell>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell><strong>Permitir a los vendedores modificar productos vendidos despues de recibir un pago y/o imprimir la comanda o factura </strong></Table.Cell>
                                        <Table.Cell>
                                            <Table.Cell colSpan={2}>
                                                <Checkbox toggle checked={this.state.data.lock_sale_items} value={this.state.data.lock_sale_items} name='lock_sale_items' label={`${this.state.data.lock_sale_items ? 'Si' : 'No'}`} onChange={this.handleToggleChange}/>
                                            </Table.Cell>
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Grid.Column>
                    </Grid.Row>:<Grid.Row centered><Loading/></Grid.Row>}
                </Grid>
                <CheckPermission access='others_securities'/>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(toast){
            dispatch(showToast(toast))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(OtherSecurities)



// WEBPACK FOOTER //
// ./src/containers/security/OtherSecurities.js